import React, { FC } from 'react';
import { Image as ChakraUiImage, ImageProps, AspectRatio as ChakraUiAspectRatio } from '@chakra-ui/react';

interface Props {
  align?: 'center' | 'left' | 'right';
  aspectRatio?: number;
  description?: string;
  height?: string;
  id?: string;
  path: string;
  sizes?: string;
  srcSet?: string;
  width?: string;
  objectFit?: 'fill' | 'contain' | 'cover' | 'none' | 'scale-down';
  fallbackSrc?: string; // Fallback image src to show if image is loading or image fails.
  imageProps?: ImageProps;
}

export const Image: FC<Props> = ({
  align = 'center',
  aspectRatio,
  description,
  height = 'auto',
  id,
  path,
  sizes,
  srcSet,
  width = '100%',
  objectFit,
  fallbackSrc,
  imageProps = {},
  ...rest
}) => {
  /**
   * DOM
   */
  const props: ImageProps = {
    align,
    id,
    src: path,
    alt: description,
    sizes,
    srcSet,
    objectFit,
    ...imageProps,
  };
  if (aspectRatio) {
    return (
      <ChakraUiAspectRatio data-object-type="core-aspect-ratio" ratio={aspectRatio} w={width} h={height}>
        <ChakraUiImage data-object-type="core-image" fallbackSrc={fallbackSrc} objectFit={objectFit} {...props} />
      </ChakraUiAspectRatio>
    );
  }
  return (
    <ChakraUiImage
      data-object-type="core-image"
      fallbackSrc={fallbackSrc}
      objectFit={objectFit}
      {...props}
      htmlWidth={width}
      htmlHeight={height}
      {...rest}
    />
  );
};
